module.exports = __webpack_public_path__ + "img/1.b1cf12d1.png";